import { inject, Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable, from, throwError } from 'rxjs';
import { UserResponse,UserRequest } from '../../models/serviceModels/response/user.model';
import { Rol } from '../../models/serviceModels/response/Rol.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CalTokenService } from '../security/cal-token.service';

@Injectable({
    providedIn: 'root'
  })
  export class UserService {
      private apiService = inject(ApiService);
      private http = inject(HttpClient);
      private calTokenService = inject(CalTokenService);

      private normalizeGraphScopes(scopes: string[]): string[] {
        return (scopes || []).map((s) => {
          const scope = (s || '').trim();
          if (!scope) return scope;
          if (scope.includes('://')) return scope;
          if (scope.startsWith('api://')) return scope;
          if (scope.startsWith('https://')) return scope;
          return `https://graph.microsoft.com/${scope}`;
        }).filter(Boolean);
      }

    getFacilityUsers(): Observable<UserResponse[]>{
        return this.apiService.get('users/GetFacilityUsers' );
    }

    editFacilityUsers(userRequest: UserRequest): Observable<UserResponse[]>{
        return this.apiService.put('/users/EditFacilityUsers',userRequest );
    }

    addFacilityUsers(userRequest: UserRequest): Observable<UserResponse>{
        return this.apiService.post('users/AddFacilityUsers',userRequest );
    }
    getAllRoles(): Observable<Rol[]>{
        return this.apiService.get('users/GetAllRoles' );
    }

    getFacilityUsersByEmail(email: string): Observable<UserResponse> {
        const body: UserRequest = { email };
        return this.apiService.post('users/GetFacilityUsersByEmail', body);
    }

    getUserFromGraph(email: string): Observable<{ displayName: string; mail: string }> {
      const scopes = this.normalizeGraphScopes(environment.graphScopes);
      // Never allow interactive auth from Graph lookups.
      return from(this.calTokenService.getAccessToken(scopes)).pipe(
        switchMap((token) => {
          if (!token) return throwError(() => new Error('No Graph access token available'));
          const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          });
          
          return this.http.get<any>(
            `https://graph.microsoft.com/v1.0/users/${email}?$select=displayName,mail,userPrincipalName`,
            { headers }
          ).pipe(
            map(user => ({
              displayName: user.displayName || '',
              mail: user.mail || user.userPrincipalName || ''
            })),
            catchError(error => {
              console.error('Error fetching user from Graph:', error);
              return throwError(() => error);
            })
          );
        })
      );
    }
  }